import { createApiRef } from '@backstage/core-plugin-api';
import type { Entity } from '@backstage/catalog-model';

export interface Filter {
  id: string;
  name: string;
}

export interface ListFiltersResponse {
  filters: Filter[];
  _meta: {
    total: number;
  };
}

export interface GetFilterValuesResponse {
  values: string[];
  _meta: {
    total: number;
  };
}

export interface GetEntitiesResponse {
  entities: Entity[];
  _meta: {
    total: number;
    failedChunks?: number;
  };
}

export interface GetEntityRefsResponse {
  entityRefs: string[];
  maskedEntityRefs: string[];
  _meta: {
    total: number;
    failedChunks?: number;
  };
}

export const pdpFilterRef = createApiRef<PdpFilterApi>({
  id: 'plugin.pdp-filter.service',
});

export interface PdpFilterApi {
  listFilters: () => Promise<ListFiltersResponse>;
  getFilterValues: (filterId: string) => Promise<GetFilterValuesResponse>;
  getEntities(
    filters: Record<string, string[]>,
    includeComponentsForBU: boolean,
    volumeTesting?: boolean,
  ): Promise<GetEntitiesResponse>;
  getEntityRefs(
    filters: Record<string, string[]>,
    includeComponentsForBU: boolean,
    userOwnershipRefs?: string[],
    volumeTesting?: boolean,
  ): Promise<GetEntityRefsResponse>;
  isHrLeader(identity: any): Promise<boolean>;
}
